var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('upload-sales-data'),_c('upload-outstanding-bills'),_c('upload-bills-zip')],1)}
var staticRenderFns = []

export { render, staticRenderFns }